"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTo = void 0;
var curry_1 = require("./curry");
/**
 *
 * Takes a value and applies it to a function
 *
 * @category Function
 * @param {*} value - the value that will be applied
 * @param {Function} function - the function that will receive the value
 * @returns {*} the return of applied function with the value
 *
 * @example
 * const increment = x => 1
 * applyTo(1, increment) // => 2
 */
exports.applyTo = (0, curry_1.curry)(function (value, fn) { return fn(value); });
